import React from "react";
import TextInput from "../../refresh/inputs/TextInput";

const LinkElement = ({ onChange, value }) => {
  return (
    <TextInput
      label="embed url"
      required
      value={value.url}
      onChange={url => onChange({ url })}
    />
  );
};

export default LinkElement;
